import { useEffect } from 'react';
import { useTitle } from '../HooksPublic';
import { Header } from 'react-frontier';
import { Icon } from 'semantic-ui-react'
import { CDN_URL } from '../ConfigPublic';

import '../style/visit_us.scss'

const BRANCHES = [
	// {
	// 	name: 'Suc. Río de la plata',
	// 	address: 'Río de la Plata 408 Ote., Del Valle, San Pedro Garza García, NL 66220',
	// 	schedule: 'Lunes - Viernes : 11am - 7pm\nSábado : 11am - 6pm\nDomingo: Cerrado',
	// 	map_src: `https://www.google.com/maps/embed/v1/place?q=R%C3%ADo%20de%20la%20plata%20408%2C%20Del%20Valle%2C%20San%20Pedro%20Garza%20Garc%C3%ADa&key=${process.env.REACT_APP_PLACES_KEY}`,
	// 	img: `${CDN_URL}/static/visit_us/PLATA.webp`
	// },
	{
		name: 'Suc. Río Manzanares',
		address: 'Río Manzanares 425, Del Valle, 66220 Monterrey, N.L.',
		schedule: 'Lunes - Viernes : 11am - 7pm\nSábado : 11am - 6pm\nDomingo: Cerrado',
		map_src: `https://www.google.com/maps/embed/v1/place?q=place_id:ChIJecQfM-S9YoYRedl-Tdt7jbs&key=${process.env.REACT_APP_PLACES_KEY}`,
		img: `${CDN_URL}/static/visit_us/MANZANA.webp`
	}
];

var VisitUs = ()=>{
	var { setTitle } = useTitle();

	useEffect(()=>{
		setTitle('COCOAN - Vísitanos', false);
	}, []);

	return <div className='co visit-us-screen'>
		<div className="hero-banner" style={{ backgroundImage: `url('${CDN_URL}/static/visit_us/BANNER_UBICACIONES.webp')` }}>
			<div className="hero-content">
				Llegaste al mejor <span className="font-homemade">lugar</span>
			</div>
		</div>
		
		<div className='main-content'>
			<div className="branch-list">
				{BRANCHES.map((branch, idx) => (
					<div className="branch-row" key={`branch-${idx}`}>
						<div className="branch-image-container">
							<img src={branch.img} alt={branch.name} className="branch-image" />
						</div>
						<div className="branch-info">
							<Header text={branch.name} centered={false} className="branch-title" />
							
							<div className="branch-details">
								<div className="detail-item">
									<Icon name="map marker alternate" />
									<div className="detail-text">
										{branch.address.split('\n').map((line, i) => (
											<span key={i}>{line}<br/></span>
										))}
									</div>
								</div>
								
								<div className="detail-item">
									<Icon name="clock outline" />
									<div className="detail-text schedule-text">
										<strong>Horario</strong><br/>
										{branch.schedule.split('\n').map((line, i) => (
											<span key={i}>{line}<br/></span>
										))}
									</div>
								</div>
							</div>

							<iframe
								width="100%"
								height="200"
								referrerPolicy="no-referrer-when-downgrade"
								title={`Map ${branch.name}`}
								src={branch.map_src}
								style={{ border: '1px solid #ececec', borderRadius: 12, marginTop: 15 }}
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	</div>
}

export default VisitUs;